/*
 * @Description: 国际化语言包切换
 * @Author: mdb
 * @Date: 2022-05-24 16:44:08
 * @LastEditTime: 2023-03-08 14:45:45
 * @LastEditors: mdb
 */
import { ref, unref } from 'vue'
import dayjs from 'dayjs'
import { useI18n } from 'vue-i18n'
import { DcLocale } from '@dc-platform/dc-components'
import type { Locale } from 'ant-design-vue/es/locale-provider'
import zhCN from 'ant-design-vue/es/locale/zh_CN'
import enUS from 'ant-design-vue/es/locale/en_US'
import 'dayjs/locale/zh-cn'
import 'dayjs/locale/en'

enum DayjsLanguageEnum {
  'zh-cn' = 'zh-cn', // 简体中文（为了兼容主应用老版本）
  'en-us' = 'en', // 英文(为了兼容主应用老版本)
  'zh-CN' = 'zh-cn', // 简体中文
  'en-US' = 'en' // 英文
}
// enum AntdLanguageEnum {
//   'zh-cn' = 'zh_CN', // 简体中文（为了兼容主应用老版本）
//   'en-us' = 'en_US', // 英文(为了兼容主应用老版本)
//   'zh-CN' = 'zh_CN', // 简体中文
//   'en-US' = 'en_US', // 英文
// }
const antdLanguageEnum = {
  'zh-CN': { ...zhCN, ...DcLocale.zhCN }, // 简体中文
  'en-US': { ...enUS, ...DcLocale.enUS } // 英文
}

const antdLanguage = ref<Locale>()

export default function () {
  const { locale } = useI18n()

  const languageToggle = (language: string): void => {
    if (language == null) return

    antdLanguage.value = antdLanguageEnum[language]
    dayjs.locale(DayjsLanguageEnum[language])
    const languageUnref = unref(language)
    locale.value = languageUnref
  }
  return { antdLanguage, languageToggle }
}
